import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from 'foundations-assets/icons/useIconSize';
import { StyledIcon } from 'foundations-assets/icons/StyledIcon';
import { getDataProps } from 'foundations-assets/icons/getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const BreezeSingleStarIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "BreezeSingleStar",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M29.62 15.12c-6.94 0-12.74-5.79-12.74-12.73 0-.48-.4-.88-.88-.88s-.88.4-.88.88c0 6.94-5.8 12.73-12.74 12.73-.49 0-.88.4-.88.88 0 .49.39.88.88.88 6.94 0 12.74 5.79 12.74 12.73 0 .48.4.88.88.88s.88-.4.88-.88c0-6.94 5.8-12.73 12.74-12.73.49 0 .88-.4.88-.88 0-.49-.39-.88-.88-.88"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M1 15.86c8.2 0 14.86-6.65 14.86-14.86 0 8.2 6.65 14.86 14.86 14.86-8.2 0-14.86 6.65-14.86 14.86 0-8.2-6.65-14.86-14.86-14.86"
      }), /*#__PURE__*/_jsx("path", {
        d: "M15.86 31.86c-.63 0-1.14-.51-1.14-1.14 0-7.56-6.15-13.71-13.71-13.71a1.14 1.14 0 1 1 0-2.28c7.56 0 13.71-6.15 13.71-13.71a1.14 1.14 0 1 1 2.28 0c0 7.56 6.15 13.71 13.71 13.71a1.14 1.14 0 1 1 0 2.28C23.15 17.01 17 23.16 17 30.72c0 .63-.51 1.14-1.14 1.14m-8.92-16a16.1 16.1 0 0 1 8.92 8.92 16.1 16.1 0 0 1 8.92-8.92 16.14 16.14 0 0 1-8.92-8.92 16.1 16.1 0 0 1-8.92 8.92"
      })]
    })
  }));
};
BreezeSingleStarIcon.displayName = 'BreezeSingleStarIcon';